import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, Lock } from 'lucide-react';
export function SignUpForm() {
  return <section className="bg-white py-16 md:py-24" data-id="element-168">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-170">
          {/* Left Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-center" data-id="element-171">
            <p className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-172">
              Sign Up Today
            </p>
            <h2 className="text-brand-black text-[32px] md:text-[42px] leading-tight font-serif mb-6" data-id="element-173">
              Get Your Free Phone or Tablet
            </h2>
            <p className="text-brand-charcoal/80 text-base md:text-lg mb-10 leading-relaxed" data-id="element-174">
              Service is subject to a one-time $23 activation fee. Device and
              service are completely free for qualifying households. Fill out
              the form and a Prime Nation specialist will contact you within 24
              hours.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 sm:gap-8" data-id="element-175">
              <div className="flex items-center gap-3" data-id="element-176">
                <ShieldCheck className="text-brand-gold" size={24} data-id="element-177" />
                <span className="font-semibold text-brand-black" data-id="element-178">
                  100% Confidential
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-179">
                <Lock className="text-brand-gold" size={24} data-id="element-180" />
                <span className="font-semibold text-brand-black" data-id="element-181">
                  No Credit Check
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-182">
                <Clock className="text-brand-gold" size={24} data-id="element-183" />
                <span className="font-semibold text-brand-black" data-id="element-184">
                  Same Day Service
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-cream border-t-4 border-brand-gold rounded-xl p-6 md:p-8 shadow-lg" data-id="element-185">
            <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-186">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-187">
                <div data-id="element-188">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-189">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-190" />
                </div>
                <div data-id="element-191">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-192">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-193" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-194">
                <div data-id="element-195">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-196">
                    Email
                  </label>
                  <input type="email" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-197" />
                </div>
                <div data-id="element-198">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-199">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-200" />
                </div>
              </div>

              <div data-id="element-201">
                <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-202">
                  Street Address
                </label>
                <input type="text" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-203" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5" data-id="element-204">
                <div className="sm:col-span-2" data-id="element-205">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-206">
                    City
                  </label>
                  <input type="text" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-207" />
                </div>
                <div data-id="element-208">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-209">
                    State
                  </label>
                  <input type="text" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-210" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-211">
                <div data-id="element-212">
                  <label className="block text-sm font-semibold text-brand-black mb-1.5" data-id="element-213">
                    Date of Birth
                  </label>
                  <input type="date" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-214" />
                </div>
                <div data-id="element-215">
                  <label className="flex items-center gap-1.5 text-sm font-semibold text-brand-black mb-1.5" data-id="element-216">
                    Last 4 of SSN
                    <Lock size={14} className="text-brand-gold" title="Encrypted securely" data-id="element-217" />
                  </label>
                  <input type="text" maxLength={4} placeholder="XXXX" className="w-full bg-white border border-gray-200 rounded px-4 py-3 min-h-[44px] focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" required data-id="element-218" />
                </div>
              </div>

              <div className="space-y-4 pt-4 border-t border-gray-200" data-id="element-219">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-220">
                  <input type="checkbox" className="mt-1 w-5 h-5 rounded border-gray-300 text-brand-gold focus:ring-brand-gold" required data-id="element-221" />
                  <span className="text-xs text-brand-charcoal/80 leading-relaxed group-hover:text-brand-black transition-colors" data-id="element-222">
                    I agree to receive SMS messages from Prime Nation regarding
                    my application status, appointments, and program updates.
                    Message and data rates may apply. Reply STOP to unsubscribe.
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-223">
                  <input type="checkbox" className="mt-1 w-5 h-5 rounded border-gray-300 text-brand-gold focus:ring-brand-gold" required data-id="element-224" />
                  <span className="text-xs text-brand-charcoal/80 leading-relaxed group-hover:text-brand-black transition-colors" data-id="element-225">
                    I agree to the Privacy Policy and Terms of Use.
                  </span>
                </label>
              </div>

              {/* Placeholder for Cloudflare Turnstile */}
              <div className="bg-gray-100 h-[65px] rounded flex items-center justify-center text-xs text-gray-400 border border-gray-200" data-id="element-226">
                Cloudflare Turnstile Verification
              </div>

              <button type="submit" className="w-full bg-brand-gold text-brand-black py-4 rounded font-bold text-base hover:bg-yellow-500 transition-colors min-h-[52px] shadow-md" data-id="element-227">
                Apply Now
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}